import React from 'react';
import styled from 'styled-components';

const HeaderText = props => <Wrapper {...props}>{props.children}</Wrapper>;

const Wrapper = styled.h4`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.44;
  color: #3e3f42;
`;

export default HeaderText;
